<template>
  <div>
    <div class="content-title">
      <div class="content-word">
        <div class="word wow animate__fadeOut">产品服务内容</div>
        <div class="serve">SERVICES</div>
      </div>
      <!-- 产品服务内容tab切换 -->
      <div class="content-wisdom">
        <div
          v-for="(item, index) in tabList"
          class="content-wisdom"
          :key="index"
          :class="{ active: currentIndex === index }"
          @click="changeTab(index)"
        >
          <span class="wow animate__zoomIn"> {{ item.title }}</span>
        </div>
      </div>
    </div>
    <div class="wisdom">
      <div class="wisdom-main">
        <div
          class="wisdom-main"
          v-for="(item, index) in tabList"
          :key="index"
          :class="item.title"
          v-show="currentIndex === index"
        >
          <div class="wisdom-left">
            <div
              class="wisdom-video"
              :class="currentIndex === index ? 'wow animate__fadeInLeft' : ' '"
            >
              <img :src="item.image" alt="" />
              <div class="wisdom-more">MORE ＞</div>
            </div>
          </div>
          <div
            class="wisdom-right"
            :class="currentIndex === index ? 'wow animate__fadeInRight' : ' '"
          >
            <div class="remote-prod">{{ item.msg }}</div>
            <div class="remote-prod-content">
              <span> {{ item.text }}</span>
            </div>
            <div class="remote-prod-content">
              <span>{{ item.detail }}</span>
            </div>
            <div class="remote-prod-content">
              <span>{{ item.textTwo }}</span>
            </div>
            <div class="remote-prod-content">
              <span>{{ item.detailTwo }}</span>
            </div>
            <div class="remote-prod-content">
              <span>{{ item.textThree }}</span>
            </div>
            <div class="remote-prod-content">
              <span>{{ item.detailThree }}</span>
            </div>
            <div class="remote-prod-content">
              <span>{{ item.textFour }}</span>
            </div>
            <div class="remote-prod-content">
              <span>{{ item.detailFour }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import videoImage from "../../../../assets/videoOne.png";
import videoImageOne from "../../../../assets/videoTwo.png";
import videoThree from '../../../../assets/videoTree.png'
export default {
  data() {
    return {
      currentIndex: 0, // 当前选择的tab
      tabList: [
        {
          title: "智慧转播服务",
          msg:'智慧转播服务',
          image: videoImage,
          text:'1.远程制作',
          detail:'为大型体育赛事、体育活动、文艺演出等活动提供轻量化、低成本、超高清和低时延的直播制作业务。',
          textTwo:'2.特殊拍摄制作服务',
          detailTwo:'为大型体育赛事提供8K、VR虚拟现实、子弹时间、自由视角、多机位等信号制作服务。',
          textThree:'3.奇点赛事制作中心',
          detailThree:'奇点赛事制作中心具备广电级技术保障标准，安全稳定、灵活高效，满足24×7全天候不间断赛事公用信号制作业务需求。',
          textFour:'4. MMC建设与咨询服务',
          detailFour:'为大型专业体育场馆提供智慧化建设、智慧转播、信号制作类的工程建设的规划-设计-建设-运营一体化全流程运营咨询咨询服务。'
        },
        {
          title: "智慧转播平台",
          msg:'智慧转播平台',
          image: videoThree,
          text:'1.直播连线',
          detail:'基于奇点智播“智慧转播”SaaS平台，为体育赛事演播室制作、赛事活动现场采访等场景提供远程线上直播连线功能的产品，包括面向嘉宾的用户界面和面向播控端的管理平台。',
          textTwo:'2.云传输',
          detailTwo:'',
          textThree:'3.云媒资',
          detailThree:'',
          textFour:'4. 云导播',
          detailFour:''
        },
        {
          title: "智慧观赛平台",
          msg:'智慧观赛平台',
          image: videoImageOne,
          text:'1.1. VIIIU智慧观赛应用',
          detail:'为大型体育场馆、全民健身场地的现场观众和用户提供自由视角、VR、多视角等观赛、精彩集锦、赛事信息、互动社交等功能的APP。',
          textTwo:'2.场馆管理平台',
          detailTwo:'为场馆提供标准化服务的系统性平台，针对场地、观众、商铺、大型赛事活动等，利用大数据收集与整合、云平台等能力，对用户、商品、媒资、营销活动等进行管理。',
          textThree:'',
          detailThree:'',
          textFour:'',
          detailFour:''
        },
      ]
    };
  },
  methods:{
    changeTab(index) {
      this.currentIndex = index;
    },
  }
};
</script>
<style lang="less" scoped>
@import './content-product.less';
</style>



// WEBPACK FOOTER //
// src/views/home/components/content-product/content-product.vue